import { h } from '@stencil/core';

const ArrowBottom = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2.4L12 19.2M12 19.2L6 13.9689M12 19.2L18 13.9689" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M18 21.2L6 21.2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>

    );
}

export default ArrowBottom;
